import { useCallback } from 'react';
import { Column } from '@ru-digital-assets/ui-component/dist/stories/table';
import cn from 'classnames';
import { ISignerInfo } from 'constants/signers';
import styles from './row-component.module.scss';
import { useHistory } from 'react-router';

export interface IRowComponent {
  rowData: ISignerInfo;
  columns: Column<ISignerInfo>[];
}

export default function RowComponent({ rowData, columns }: IRowComponent) {
  const history = useHistory();

  const onRowComponentClick = useCallback(() => {
    history.push(`/operator/signer-card/${rowData.userId}`, {
      id: rowData.userId,
    });
  }, [rowData]);

  return (
    <div className={styles.row} onClick={onRowComponentClick}>
      {columns.map((column) => {
        const columnData = column.dataGetter(rowData) || '';
        return (
          <div
            className={cn(styles['row__column'], styles[`row__${column.name}`])}
            style={{ ...column.headerStyle }}
            key={column.name}
          >
            {column.Component ? (
              <column.Component data={rowData} />
            ) : (
              columnData
            )}
          </div>
        );
      })}
    </div>
  );
}
